<template>
  <div class="yqjl">
    <van-nav-bar
        title="用气记录"
        left-text="返回"
        left-arrow
        @click-left="onClickLeft"
    />

    <div class="margin0"/>

    <van-cell v-model="C_Code" icon="user-circle-o" size="large" >
      <!-- 使用 title 插槽来自定义标题 -->
      <template #title>
        <span class="custom-title">{{C_Name}}</span>
      </template>
    </van-cell>
    <van-cell  icon="wap-home-o">
      <template #title>
        <span class="custom-title2">{{C_Address}}</span>
      </template>
    </van-cell>

    <div class="margin1"/>

    <van-notice-bar color="#1989fa" background="#ecf9ff" left-icon="info-o">
      仅显示一年内的用气记录
    </van-notice-bar>

    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
      >
        <van-cell-group v-for="(item,index) in list" :key="item.id" @click="faDetail(index)" >
          <van-cell  v-model="item.FA_NDate" icon="calendar-o" size="large" is-link>
            <!-- 使用 title 插槽来自定义标题 -->
            <template #title>
              <span class="custom-title">抄表日期  </span>
              <van-tag v-if="item.FA_Flag === '销账'" type="success">{{item.FA_Flag}}</van-tag>
              <van-tag v-if="item.FA_Flag === '欠费'" type="danger">{{item.FA_Flag}}</van-tag>
              <van-tag v-if="item.FA_Flag === '扣费途中'" type="warning">{{item.FA_Flag}}</van-tag>
              <van-tag v-if="item.FA_Flag === '微信扣费中'" type="warning">{{item.FA_Flag}}</van-tag>
            </template>
          </van-cell>
          <van-cell title="用气量" v-model="item.FA_Count" icon="bar-chart-o"/>
          <van-cell title="总气费" v-model="item.FA_Fee" icon="gold-coin-o"/>
          <van-cell title="违约金" v-model="item.FA_LateFee" icon="refund-o"/>
          <van-cell title="已缴气费" v-model="item.FA_Pay" icon="points"/>
        </van-cell-group>

      </van-list>
    </van-pull-refresh>


  </div>
</template>
<script>
import API from './../api/index';
//import { Toast } from 'vant';
export default {
  name: 'page_yqjl',
  data() {
    return {
      C_ID:"",
      C_Code:"",
      C_Name:"",
      C_Address:"",
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
    }
  },
  methods: {
    onClickLeft(){
      this.$router.go(-1);
    },
    getCust() {
      this.C_ID=this.$cookie.get('CID');
      this.C_Code=this.$cookie.get('C_Code');
      this.C_Address=this.$cookie.get('CAddress');
      this.C_Name=this.$cookie.get('CName');
    },
    onLoad() {
      setTimeout(() => {
        if (this.refreshing) {
          this.list = [];
          this.refreshing = false;
        }

        this.$http.get(API.LookFeeAllByWX,{
          params: {
            c_id:this.C_ID
          }
        })
            .then((response)=>{
              let res = response.data;
              if (res.code == 0) {
                this.list=res.subdata;
                this.$cookie.set('feeall',res.subdata,  { expires: '360m' });
              } else {
                this.loading = false;
                this.finished= true;
              }
            });

        this.loading = false;

        if (this.list.length) {
          this.finished = true;
        }
      }, 1000);
    },
    onRefresh() {
      // 清空列表数据
      this.finished = false;

      // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.onLoad();
    },
    faDetail (index) {
      this.$cookie.set('fa_index',index,  { expires: '360m' });
      this.$router.push('/feeall');
    }
  },
  mounted () {
    this.getCust();
  }
}
</script>
<style>
.index{
  height: 100vh;
  background-color: #f5f5f5;
}
.margin1{
  height: 0.5rem;
  background-color: #f5f5f5;
}
.margin0{
  height: 0.5rem;
  background-color: #f5f5f5;
}
.custom-title {
  margin-right: 4px;
  vertical-align: middle;
}

</style>